module.exports = __webpack_public_path__ + "media/icons/widget-icon-3-fe267c11.png";